export default function SkeletonBlogCard() {
  return (
    <div className="flex flex-col p-5 border-r border-b border-gray-200 h-full animate-pulse">
      {/* Image */}
      <div className="w-full aspect-[3/2] rounded-lg bg-gray-200 mb-4" />

      {/* Title */}
      <div className="h-4 w-11/12 bg-gray-200 rounded mb-2" />
      <div className="h-4 w-2/3 bg-gray-200 rounded mb-4" />

      {/* Description */}
      <div className="space-y-2 mb-5">
        <div className="h-3 w-full bg-gray-200 rounded" />
        <div className="h-3 w-5/6 bg-gray-200 rounded" />
      </div>

      {/* Read more */}
      <div className="mt-auto">
        <div className="h-8 w-28 bg-gray-200 rounded-md" />
      </div>
    </div>
  );
}
